if (!window.customElements.get('yg-mega-menu-2')) {
  class YGMegamenu2 extends HTMLElement {
    constructor() {
      super();
      this.style.display = 'flex';
      this.init();
    }

    init() {
      const nav_list = this.querySelectorAll('.yg-mega-nav-item');
      const product_list = this.querySelectorAll('.yg-collection-item');
      let active_index = 0;

      nav_list[active_index].classList.add('active');
      product_list[active_index].style.display = 'block';

      nav_list.forEach((item, index) => {
        item.addEventListener('mouseover', () => {
          nav_list[active_index].classList.remove('active');
          product_list[active_index].style.display = 'none';

          active_index = index;

          nav_list[active_index].classList.add('active');
          product_list[active_index].style.display = 'block';
        });
      });
    }
  }

  window.customElements.define('yg-mega-menu-2', YGMegamenu2);
}

class YGScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

if (!window.customElements.get('yg-nav')) {
  class YGNav extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.style.display = 'flex'
    }

    init() {
      const nav_list = this.querySelectorAll('.yg-nav-item');
      const content_list = this.querySelectorAll('.yg-content-item');
      const more_block = this.querySelectorAll('.yg-tab-more-wrapper');
      const less_block = this.querySelectorAll('.yg-tab-less-wrapper');
      const more_btn = this.querySelectorAll('.yg-tab-more');
      const less_btn = this.querySelectorAll('.yg-tab-less');

      let active_index = 0;
      const show_num = Number(this.getAttribute('data-num'));
      nav_list[active_index].classList.add('active');
      content_list[active_index].style.display = 'block';

      
      
      more_block.forEach((item, index) => {

        const li_list_block = content_list[index].querySelector('.yg-li-list');
        if (li_list_block.offsetHeight >= 85) {
          item.style.display = 'flex';
          li_list_block.style.height = '85px';
        }
        else{
          item.style.display = 'none';
        }
        // const li_list = li_list_block.querySelectorAll('li')
        // if (li_list.length > show_num) {
        //   if (li_list.length > show_num) {
        //     for (let i = show_num; i < li_list.length; i++) {
        //       li_list[i].style.display = 'none';
        //     }
        //   }
        // }
      })

      nav_list.forEach((item, index) => {
        item.addEventListener('click', () => {
          nav_list[active_index].classList.remove('active');
          content_list[active_index].style.display = 'none';

          active_index = index;

          nav_list[active_index].classList.add('active');
          content_list[active_index].style.display = 'block';

          const li_list_block = content_list[index].querySelector('.yg-li-list');
          if (li_list_block.offsetHeight >= 85) {
            more_block[index].style.display = 'flex';
            less_block[index].style.display = 'none';
            li_list_block.style.height = '85px';
          }
          else{
            more_block.style.display = 'none';
          }
        })

       
      })

      more_btn.forEach((item, index) => {
        // const li_list_block = content_list[index].querySelector('.yg-li-list');
        // const li_list = li_list_block.querySelectorAll('li')
        // if (li_list.length > show_num) {
        //   item.addEventListener('click', () => {
        //     const li_list_block = content_list[index].querySelector('.yg-li-list');
        //     const li_list = li_list_block.querySelectorAll('li');

        //     li_list.forEach(item => {
        //       item.style.removeProperty('display');
        //     })

        //     more_block[index].style.display = 'none';
        //     less_block[index].style.display = 'flex';
        //   })
        // } else {
        //   more_block[index].style.display = 'none';
        // }

        item.addEventListener('click', () => {
          const li_list_block = content_list[index].querySelector('.yg-li-list');
          li_list_block.style.height = 'auto';
          more_block[index].style.display = 'none';
          less_block[index].style.display = 'flex';
          
        })
      })

      less_btn.forEach((item, index) => {
        // const li_list_block = content_list[index].querySelector('.yg-li-list');
        // const li_list = li_list_block.querySelectorAll('li')
        // if (li_list.length > show_num) {
        //   item.addEventListener('click', () => {
        //     const li_list_block = content_list[index].querySelector('.yg-li-list');
        //     const li_list = li_list_block.querySelectorAll('li');

        //     if (li_list.length > show_num) {
        //       if (li_list.length > show_num) {
        //         for (let i = show_num; i < li_list.length; i++) {
        //           li_list[i].style.display = 'none';
        //         }
        //       }
        //     }

        //     less_block[index].style.display = 'none';
        //     more_block[index].style.display = 'flex';
        //   })
        // }
        item.addEventListener('click', () => {
          const li_list_block = content_list[index].querySelector('.yg-li-list');
          li_list_block.style.height = '85px';
          less_block[index].style.display = 'none';
          more_block[index].style.display = 'flex';
        })
      })
    }
  }

  window.customElements.define('yg-nav', YGNav);
}

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.variations fieldset.product-form__input');

  const input_list = form.querySelectorAll('input');
  const select = document.querySelector('yg-select');
  let timer = null;
  const shadowRoot = select.shadowRoot;
  const t = shadowRoot.querySelector('.yg-select-placeholder');
  input_list.forEach(input => {
    
    
    if(input.hasAttribute('checked')){
      t.innerText = input.value;
    }
    
  })

  document.querySelectorAll('yg-option').forEach(option => {
    if (option.shadowRoot.querySelector('li').classList.contains('yg-active') ) {
      option.shadowRoot.querySelector('li').classList.remove('yg-active');
    }

    if (option.shadowRoot.querySelector('li').innerText === t.innerText) {
      option.shadowRoot.querySelector('li').classList.add('yg-active');
    } 
  });

  form.addEventListener('click', (e) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      const priceDom = document.querySelector('.yg-tab-button-price')
      const price = document.querySelector('.product-price-container .price')
      let tempContainer = document.createElement('div');
      tempContainer.innerHTML = price.parentNode.innerHTML;
              
      let badgesElement = tempContainer.querySelector('.badges');
      if (badgesElement) {
          badgesElement.remove();
      }

      priceDom.innerHTML = tempContainer.innerHTML;
    }, 800)
  })

  let flag = 0;
  let position = 0;
  if (form) {
    if (form.classList.contains('product-form__input--block')) {
      const label_list = form.querySelectorAll('label');

      window.addEventListener('option-selected', (e) => {
        const options_text = e.detail.value.split('/').map(item => item.trim());
        flag = 1;
        position = window.scrollY;        
        label_list.forEach(label => {
          options_text.forEach(text => {
            if (label.previousElementSibling.getAttribute('value') === text) {
              label.click();

              setTimeout(() => {
                flag = 0;
              }, 100);
            }
          })
        })
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          const priceDom = document.querySelector('.yg-tab-button-price')
          const price = document.querySelector('.product-price-container .price')
          let tempContainer = document.createElement('div');
          tempContainer.innerHTML = price.parentNode.innerHTML;
                  
          let badgesElement = tempContainer.querySelector('.badges');
          if (badgesElement) {
              badgesElement.remove();
          }

          priceDom.innerHTML = tempContainer.innerHTML;
        }, 800)
      })
    } else if (form.classList.contains('product-form__input--dropdown')) {
      const options = form.querySelectorAll('select option');
      const select = form.querySelector('select');

      window.addEventListener('option-selected', (e) => {
        flag = 1;
        position = window.scrollY;       

        const obj = e.detail;
        options.forEach((option, index) => {
          if (option.getAttribute('value') === obj.value) {
            select.selectedIndex = index;
            select.value = obj.value;
            const changeEvent = new Event('change', { bubbles: true });
            select.dispatchEvent(changeEvent);

          }
        })
        setTimeout(() => {
          flag = 0;
        }, 100);
      })

      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        const priceDom = document.querySelector('.yg-tab-button-price')
          const price = document.querySelector('.product-price-container .price')
        let tempContainer = document.createElement('div');
        tempContainer.innerHTML = price.outerHTML;
                
        let badgesElement = tempContainer.querySelector('.badges');
        if (badgesElement) {
            badgesElement.remove();
        }

        priceDom.innerHTML = tempContainer.innerHTML;
      }, 800)
    }
  }

  window.addEventListener('scroll', (e) => {
    if (flag === 1) {
      e.preventDefault();
      e.stopPropagation();
      // 强制将滚动位置重置
      window.scrollTo({
        top: position, // 根据需要调整滚动位置
        behavior: 'auto'
      });
    }
    
  });
});